import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EuiDropdownModule } from '../../components/eui-dropdown';
import { EuiUserProfileMenuComponent } from './user-profile-menu/user-profile-menu.component';
import { EuiUserProfileMenuItemComponent } from './user-profile-menu-item/user-profile-menu-item.component';

import { EuiUserProfileComponent } from './user-profile.component';

const COMPONENTS = [
    EuiUserProfileComponent,
    EuiUserProfileMenuComponent,
    EuiUserProfileMenuItemComponent,
];

@NgModule({
    imports: [
        CommonModule,
        EuiDropdownModule,
    ],
    declarations: [
        ...COMPONENTS,
    ],
    exports: [
        ...COMPONENTS,
    ],
})
export class EuiUserProfileModule { }
